import { createFileRoute } from '@tanstack/react-router';
import { TermsOfService } from '@/components/legal';

// Public route - no auth required
export const Route = createFileRoute('/terms')({
  component: TermsOfService,
});
